import { render, staticRenderFns } from "./widgetModal.vue?vue&type=template&id=e6639d40&scoped=true&"
import script from "./widgetModal.vue?vue&type=script&lang=js&"
export * from "./widgetModal.vue?vue&type=script&lang=js&"
import style0 from "./widgetModal.vue?vue&type=style&index=0&id=e6639d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6639d40",
  null
  
)

export default component.exports